<template>
  <!-- 七天试用期内弹框 -->
  <CampaignModalCon
    @saveLinkedIn="saveLinkedIn"
    v-if="visible"
    :showModal.sync="visible"
    :newLinkedIn="newLinkedIn"
  />
</template>

<script>
import { EventOnEventStart, EventEnd } from "@/layouts/dialog-config/index";
const $EventName = "global_active_campaignModal_20250110";
import CampaignModalCon from "./CampaignModalCon";

export default {
  data() {
    return {
      visible: false,
      tipTxt: "",
      newLinkedIn: [],
    };
  },
  components: {
    CampaignModalCon,
  },
  i18n: require("./i18n"),
  computed: {
    localStorageName() {
      if (this.$route.path.indexOf("/sales/salesReps") > -1) {
        return "salesNoActiveLinkedIn";
      }
      return "recruiterNoActiveLinkedIn";
    },
  },
  async created() {
    EventOnEventStart($EventName, this.eventStartModal);
  },
  methods: {
    // 关闭弹框回调
    closeModal() {
      this.visible = false;
      EventEnd($EventName);
    },
    saveLinkedIn() {
      let linkedinInfo = JSON.parse(
        localStorage.getItem(this.localStorageName) || "{}"
      );
      this.newLinkedIn.forEach((item) => {
        linkedinInfo[item] = true;
      });
      localStorage.setItem(this.localStorageName, JSON.stringify(linkedinInfo));
      this.closeModal();
    },
    async eventStartModal(data) {
      if (data && data.name === $EventName) {
        await this.$axios(
          "/linkedin/linkedin_status",
          {
            campaign_type:
              this.$route.path.indexOf("/sales/salesReps") > -1 ? 1 : 2,
          },
          "post"
        )
          .then((res) => {
            if (res.code == 200) {
              let { data } = res;
              let linkedin = this.getLocalStorageInfo(data || []);
              this.newLinkedIn = linkedin;
              if (linkedin && linkedin.length) {
                this.visible = true;
              } else {
                this.closeModal();
              }
              return;
            }
            this.closeModal();
          })
          .catch(() => {
            this.closeModal();
          });
      }
    },
    getLocalStorageInfo(list) {
      let linkedinInfo = JSON.parse(
        localStorage.getItem(this.localStorageName) || "{}"
      );
      let noShow = [];
      list.forEach((item) => {
        if (item.is_not_friend && !linkedinInfo[item.linkedin_email]) {
          noShow.push(item.linkedin_email);
        }
      });
      return noShow;
    },
  },
  // watch: {
  //   "$route.path": {
  //     immediate: true,
  //     handler() {
  //       this.visible = false
  //     },
  //   },
  // },
};
</script>
<style lang="less"></style>
